import React from "react";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import { Task } from "../../types";
import { getRecurrenceLabel } from "../../lib/recurrence";

interface RecurringChangeWarningDialogProps {
  task: Pick<
    Task,
    | "recurrence_frequency"
    | "recurrence_interval"
    | "recurrence_day_of_week"
    | "scheduled_date"
  >;
  onCancel: () => void;
  onConfirm: () => void;
}

const RecurringChangeWarningDialog: React.FC<RecurringChangeWarningDialogProps> = ({
  task,
  onCancel,
  onConfirm,
}) => {
  useEscapeKey(onCancel);

  const rhythm = getRecurrenceLabel(task).toLowerCase();

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-40 p-2 sm:p-4 animate-dialog-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div
        role="dialog"
        aria-label="Change recurring schedule"
        className="bg-warm-bg-card rounded-xl border border-warm-border p-4 sm:p-6 w-full max-w-md max-h-[95vh] overflow-y-auto animate-dialog-panel"
      >
        <h3 className="text-lg font-semibold text-warm-text-primary mb-3">
          Change recurring schedule?
        </h3>
        <p className="text-warm-text-secondary text-sm mb-5">
          This task repeats {rhythm}. Moving it will reshape the entire
          recurring series — future occurrences will move to the new schedule
          too.
        </p>

        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 bg-warm-bg-elevated hover:bg-warm-border-subtle text-warm-text-primary rounded-lg text-sm transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-warm-blue hover:bg-warm-blue-dark text-white rounded-lg text-sm transition-colors"
          >
            Change schedule
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecurringChangeWarningDialog;
